import { Card, CardHeader, CardTitle, CardContent } from "@shared/ui/card";
import { Heart, AlertTriangle, MessageSquare } from "lucide-react";

interface RelationshipInsightsProps {
  accountAge: number;
  serviceRequestCount: number;
  complaintCount: number;
  communicationPreference: string;
}

export function RelationshipInsights({
  accountAge,
  serviceRequestCount,
  complaintCount,
  communicationPreference
}: RelationshipInsightsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Heart className="h-5 w-5 text-red-500" />
          Relationship Insights
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="text-sm font-medium">Account Age</div>
              <div className="text-sm mt-1">{accountAge} months</div>
            </div>
                        
            <div>
              <div className="text-sm font-medium">Service Requests</div>
              <div className="text-sm mt-1">{serviceRequestCount} in last 12 months</div>
            </div>
            
            <div>
              <div className="text-sm font-medium">Complaints</div>
              <div className="flex items-center mt-1">
                <AlertTriangle className={`h-4 w-4 mr-1 ${complaintCount <= 2 ? 'text-green-600' : 'text-yellow-600'}`} />
                <span className="text-sm">{complaintCount} in last 12 months</span>
              </div>
            </div>
            
            <div className="col-span-2">
              <div className="text-sm font-medium">Communication Preference</div>
              <div className="flex items-center mt-1">
                <MessageSquare className="h-4 w-4 mr-1 text-blue-600" />
                <span className="text-sm capitalize">{communicationPreference}</span>
              </div>
            </div>
          </div>
          
          <div className="pt-2 border-t">
            <h4 className="text-sm font-medium mb-2">Key Insights</h4>
            <ul className="text-xs space-y-1">
              <li className="text-green-600">• Consistent payment history</li>
              <li className="text-blue-600">• Responds well to email communications</li>
              <li className="text-yellow-600">• Moderate service request frequency</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
